import { render, staticRenderFns } from "./tjzDetail.vue?vue&type=template&id=a47f7a10&scoped=true&"
import script from "./tjzDetail.vue?vue&type=script&lang=js&"
export * from "./tjzDetail.vue?vue&type=script&lang=js&"
import style0 from "./tjzDetail.vue?vue&type=style&index=0&id=a47f7a10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47f7a10",
  null
  
)

export default component.exports